import React from 'react';
export var SwatchDisplay = function SwatchDisplay(props) {
  var _props$swatches = props.swatches,
      swatches = _props$swatches === void 0 ? [// "https://s3.amazonaws.com/cbrl-ecom-images/MOZU+IMAGES/VENDORNET/SWATCHES/529993-0.jpg",
    // "https://s3.amazonaws.com/cbrl-ecom-images/MOZU+IMAGES/VENDORNET/SWATCHES/529995-0.jpg",
    // "https://s3.amazonaws.com/cbrl-ecom-images/MOZU+IMAGES/VENDORNET/SWATCHES/529998-0.jpg",
    // "https://s3.amazonaws.com/cbrl-ecom-images/MOZU+IMAGES/VENDORNET/SWATCHES/529995-0.jpg",
    // "https://s3.amazonaws.com/cbrl-ecom-images/MOZU+IMAGES/VENDORNET/SWATCHES/529998-0.jpg",
  ] : _props$swatches;
  var display = swatches.slice(0, 3);
  var excess = swatches.length - display.length;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-card__swatches"
  }, display.map(function (swatch, index) {
    return /*#__PURE__*/React.createElement("img", {
      key: index,
      src: swatch,
      alt: "swatch" + index
    });
  }), Boolean(excess > 0) && /*#__PURE__*/React.createElement("p", null, "+", swatches.length - display.length));
};